import "./CustomerDisplayId.scss";

import React from "react";

type Props = {
    customerDisplayId: string | undefined;
    isEmployee: boolean;
};

function CustomerDisplayId({ customerDisplayId, isEmployee }: Props) {
    // It was intentionally decided to show the customerId only to employees anymore
    if (isEmployee) {
        return <div className="customer-display-id">{customerDisplayId}</div>;
    }
    return null;
}

export default CustomerDisplayId;
